'use client';

import React from 'react';
import { Zap, ArrowUpRight, Package } from 'lucide-react';
import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';

// Backend integration: GET /api/seller/dashboard/top-products
const topProducts = [
{
  id: 'prod-001',
  name: 'Samsung Galaxy A55 5G — 8GB/256GB',
  sku: 'SAM-A55-256',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2e6e219-1772429765169.png",
  alt: 'Samsung Galaxy A55 5G smartphone front view black color',
  price: 'PKR 89,999',
  unitsSold: 142,
  revenue: 'PKR 12,77,886',
  stock: 23,
  stockStatus: 'ok' as const
},
{
  id: 'prod-002',
  name: 'Haier 1.5 Ton Inverter AC — HSU-18',
  sku: 'HAI-AC-18T',
  image: "https://images.unsplash.com/photo-1702443418982-9aeb9e04b322",
  alt: 'White wall-mounted air conditioner unit in room',
  price: 'PKR 1,24,500',
  unitsSold: 87,
  revenue: 'PKR 10,83,150',
  stock: 8,
  stockStatus: 'low' as const
},
{
  id: 'prod-003',
  name: 'Sony WH-1000XM5 Headphones — Black',
  sku: 'SNY-WH-XM5-BK',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18093efb3-1773063758472.png",
  alt: 'Black Sony over-ear noise cancelling headphones on white surface',
  price: 'PKR 62,000',
  unitsSold: 64,
  revenue: 'PKR 3,96,800',
  stock: 15,
  stockStatus: 'ok' as const
},
{
  id: 'prod-004',
  name: 'HP Victus 15 Gaming Laptop — i5/8GB',
  sku: 'HP-VIC-15-I5',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ef3d81d-1777043255349.png",
  alt: 'HP gaming laptop open showing colorful screen',
  price: 'PKR 1,85,000',
  unitsSold: 38,
  revenue: 'PKR 7,03,000',
  stock: 4,
  stockStatus: 'critical' as const
},
{
  id: 'prod-005',
  name: 'Logitech MX Master 3S Mouse',
  sku: 'LOG-MXM3S-GR',
  image: "https://images.unsplash.com/photo-1649563876252-f2c960c6413f",
  alt: 'Gray Logitech wireless mouse on desk',
  price: 'PKR 18,500',
  unitsSold: 211,
  revenue: 'PKR 3,90,350',
  stock: 67,
  stockStatus: 'ok' as const
}];


const stockBadge = {
  ok: <span className="badge-success">In Stock</span>,
  low: <span className="badge-warning">Low Stock</span>,
  critical: <span className="badge-danger">Critical</span>
};

export default function TopProductsTable() {
  return (
    <div className="card p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Package size={16} className="text-primary" />
          <h2 className="text-base font-semibold">Top Selling Products</h2>
        </div>
        <Link href="/product-management" className="text-xs text-primary font-semibold hover:underline flex items-center gap-1">
          View All <ArrowUpRight size={12} />
        </Link>
      </div>

      <div className="overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              {['Product', 'SKU', 'Price', 'Units Sold', 'Revenue', 'Stock', ''].map((col, i) =>
              <th
                key={`tph-${i}`}
                className="pb-2 text-xs font-semibold text-muted-foreground text-left whitespace-nowrap pr-4 last:pr-0">
                
                  {col}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {topProducts.map((product, idx) =>
            <tr
              key={product.id}
              className="table-row-hover border-b border-border/50 last:border-0">
              
                <td className="py-2.5 pr-4">
                  <div className="flex items-center gap-2.5">
                    <AppImage
                    src={product.image}
                    alt={product.alt}
                    width={36}
                    height={36}
                    className="w-9 h-9 rounded-lg object-cover border border-border shrink-0" />
                  
                    <div>
                      <p className="text-xs font-medium text-foreground leading-snug max-w-[180px] truncate" title={product.name}>
                        {product.name}
                      </p>
                      <p className="text-2xs text-muted-foreground mt-0.5">#{idx + 1} this month</p>
                    </div>
                  </div>
                </td>
                <td className="py-2.5 pr-4">
                  <code className="text-xs bg-muted px-1.5 py-0.5 rounded text-muted-foreground font-mono">
                    {product.sku}
                  </code>
                </td>
                <td className="py-2.5 pr-4 text-xs font-semibold tabular-nums whitespace-nowrap">
                  {product.price}
                </td>
                <td className="py-2.5 pr-4 text-xs font-bold tabular-nums text-center">
                  {product.unitsSold}
                </td>
                <td className="py-2.5 pr-4 text-xs font-semibold tabular-nums text-success whitespace-nowrap">
                  {product.revenue}
                </td>
                <td className="py-2.5 pr-4">
                  {stockBadge[product.stockStatus]}
                </td>
                <td className="py-2.5">
                  <button className="flex items-center gap-1 text-xs font-semibold text-accent hover:text-accent/80 whitespace-nowrap transition-colors">
                    <Zap size={11} /> Boost
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>);

}